import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import axios from 'axios'
import { setActiveMapPool } from './config/mapPool'
import { showAnalysisCapacityNotice } from './utils/analysisCapacityNotice'

// Global interceptor: auto-redirect to login on 401 Unauthorized
axios.interceptors.response.use(
  response => response,
  error => {
    showAnalysisCapacityNotice(error);
    if (error.response?.status === 401) {
      // Don't intercept the login endpoint itself — let LoginPage handle its own errors
      const url = error.config?.url || '';
      if (!url.includes('/auth/login')) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

const API = import.meta.env.VITE_API_URL || 'http://localhost:3001';

async function bootstrap() {
    // Attempt to load dynamic map pool config from backend before rendering
    try {
        const { data } = await axios.get(`${API}/map-pool`, { timeout: 8000 });
        if (data && data.activePool) {
            setActiveMapPool(data.activePool);
        }
    } catch (err) {
        console.warn('[MapPool] Failed to load dynamic map pool from API, using defaults.', err);
    }

    console.log('Cache Buster 1.0.1');

    createRoot(document.getElementById('root')!).render(
        <App />,
    );
}

bootstrap();
// force rebuild hash 04/21/2026 20:09:39
